import React from "react";
import { styled } from "@material-ui/core/styles";
import CheckIcon from "@material-ui/icons/Check";
import { Box } from "@material-ui/core";

const Stepper = styled(`div`)(({ theme }) => ({
  width: `100%`,
  padding: theme.spacing(2.5, 0, 2),
  position: "relative",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between"
}));

const Line = styled(Box)(() => ({
  height: `2px`,
  backgroundColor: `rgba(255, 255, 255, 0.14)`,
  flex: `1 1 auto`,
  "&:first-child, &:last-child": {
    flex: `0 0 auto`
  }
}));

const ActiveLine = styled(Line)(({ theme }) => ({
  backgroundColor: theme.palette.primary.main
}));

const Circle = styled(`div`)(({ theme }) => ({
  width: `36px`,
  height: `36px`,
  borderRadius: `50%`,
  background: `rgba(17, 32, 36, 0.88)`,
  opacity: 0.6,
  border: `1.5px solid ${theme.palette.grey[300]}`,
  backdropFilter: `blur(4px)`,
  color: theme.palette.grey[200],
  fontFamily: `Roobert`,
  fontSize: `1.7rem`,
  lineHeight: 1,
  display: `flex`,
  justifyContent: `center`,
  alignItems: `center`
}));

const ActiveCircle = styled(Circle)(({ theme }) => ({
  opacity: 1,
  borderColor: theme.palette.primary.main,
  color: theme.palette.primary.main,
  background: `rgba(255, 187, 0, 0.02)`
}));

const PodCircle = styled(Circle)(() => ({
  opacity: 1,
  borderColor: `rgba(255, 255, 255, 0.38)`,
  borderWidth: `1px`
}));

const ActivePodCircle = styled(ActiveCircle)(({ theme }) => ({
  backgroundColor: theme.palette.primary.main,
  borderWidth: `1px`
}));

const Pod = styled(`div`)(() => ({
  width: `100%`,
  height: `40px`,
  backgroundImage: `url(https://www.datocms-assets.com/15671/1614092435-podsp00000-1-1.png)`,
  backgroundRepeat: `no-repeat`,
  backgroundSize: `29px auto`,
  backgroundPosition: `top center`,
  borderRadius: `0px 0px 40px 40px`,
  marginBottom: `6px`
}));

type StepProps = {
  isFirst?: boolean;
  isActive?: boolean;
  isPod?: boolean;
  numberLabel: number;
};

const Step = ({ isFirst, isActive, isPod, numberLabel }: StepProps) => {
  if (isPod) {
    if (isActive) {
      return (
        <>
          <ActiveLine
            width={{
              xs: isFirst ? `62px` : `auto`,
              sm: isFirst ? `122px` : `auto`
            }}
          />
          <ActivePodCircle>
            <Pod />
          </ActivePodCircle>
        </>
      );
    } else {
      return (
        <>
          <Line />
          <PodCircle>
            <Pod />
          </PodCircle>
        </>
      );
    }
  } else {
    if (isActive) {
      return (
        <>
          <ActiveLine
            style={{ opacity: isFirst ? 0 : 1 }}
            width={{
              xs: isFirst ? `62px` : `auto`,
              sm: isFirst ? `122px` : `auto`
            }}
          />
          <ActiveCircle>
            <CheckIcon />
          </ActiveCircle>
        </>
      );
    } else {
      return (
        <>
          <Line
            width={{
              xs: isFirst ? `62px` : `auto`,
              sm: isFirst ? `122px` : `auto`
            }}
            style={{ opacity: isFirst ? 0 : 1 }}
          />
          <Circle>{numberLabel}</Circle>
        </>
      );
    }
  }
};

export default function ReferralStepper({ count = 0 }) {
  const roundStart = Math.floor(count / 3) * 3;
  const round = count % 3;
  return (
    <Stepper>
      <Step isFirst numberLabel={roundStart + 1} isActive={round > 0} />
      <Step numberLabel={roundStart + 2} isActive={round > 1} />
      <Step numberLabel={roundStart + 3} isPod />
      <Line
        width={{
          xs: `62px`,
          sm: `122px`
        }}
      />
    </Stepper>
  );
}
